import React, { useEffect } from "react";
import lottie from 'lottie-web';
import animationData from "../animation-data/stats/data.json";

function StatisticsAnimation() {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.getElementById('statistics-animation'),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: animationData,
      progressiveLoad: true,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet'
      }
    });
  },[])

  return (
    <div id="statistics-animation"></div>
  )
}

export default StatisticsAnimation;